<div class="row">
  <div class="col">
    <p class="text-primary mt-2">
      Almost done! We just need a few more details.
    </p>
    <h2>Finish &amp; Submit</h2>
  </div>
</div>

<form>
  <h3 class="text-secondary mt-3">Applicant</h3>

  <div class="row">
    <div class="col-12 col-md-8 col-lg-5">
      <app-secure-info [controls]="bankingFormGroup.controls"></app-secure-info>
    </div>
    <div class="col-12 offset-lg-1 col-lg-6">
      <app-banking-info
        [controls]="bankingFormGroup.controls"
        (applicantChangeEvent)="
          onCheckingAccountStandingChange($event, bankingFormGroup)
        "
      ></app-banking-info>
    </div>
  </div>
</form>

<div *ngIf="coApplicant">
  <form>
    <hr class="hr-style" />

    <h3 class="text-secondary mt-3">Co-Applicant</h3>

    <div class="row">
      <div class="col-12 col-md-8 col-lg-5">
        <app-secure-info
          [controls]="coApplicantBankingFormGroup.controls"
          [coApplicant]="true"
          [count]="2"
        ></app-secure-info>
      </div>
    </div>
  </form>
</div>

<hr class="hr-style" />

<form>
  <app-electronic-signature-info
    [controls]="bankingFormGroup.controls"
  ></app-electronic-signature-info>
</form>

<div class="row my-5">
  <div class="col-12 col-lg-6">
    <button
      [disabled]="isSaving"
      type="button"
      class="btn btn-primary"
      (click)="onNext()"
    >
      <span
        *ngIf="isSaving"
        class="spinner-border spinner-border-sm me-2"
        role="status"
        aria-hidden="true"
      ></span>
      <span>Submit Application</span>
    </button>

    <app-validation-text
      [show]="
        isDirtyAndMissingRequiredFields ||
        isCoAppFormDirtyAndMissingRequiredFields
      "
    ></app-validation-text>
  </div>
  <div class="col-12 col-lg-6">
    <div class="mt-3 mt-lg-0 text-center text-md-start text-lg-end">
      <button
        [disabled]="isSaving"
        class="btn btn-link"
        (click)="onFinishByPhone()"
      >
        <small> Finish Application by Phone </small>
      </button>
    </div>
  </div>
</div>
